<template>
  <div class="vs-con-loading__container" id="headServico">
    <div v-if="enderecos.length > 0">
      <div v-for="(tr, index) in enderecos" :key="index" class="address-section">
        <vs-col
          vs-w="12"
          class="p-0"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
        >
          <div class="w-full px-4">
            <VuePerfectScrollbar
              class="scroll-manage-devices-main"
              :settings="settings"
            >
              <vs-tabs
                position="left"
                color="dark"
                alignment="center"
                id="address-devices"
              >
                <vs-tab
                  icon-pack="feather"
                  icon="icon-shield"
                  label="Dispositivos"
                >
                  <devices-tab-content
                    :client="cliente"
                    :contract="contrato"
                    :address="tr"
                    :os="os"
                    :onlyActives="onlyActives"
                    :onlyPests="onlyPests"
                  />
                </vs-tab>

                <vs-tab
                  icon-pack="feather"
                  icon="icon-grid"
                  label="Planta"
                >
                  <blueprint-tab-content
                    :client="cliente"
                    :contract="contrato"
                    :address="tr"
                  />
                </vs-tab>
              </vs-tabs>
            </VuePerfectScrollbar>
          </div>
        </vs-col>
      </div>
    </div>
    <div v-else>
      <vs-row type="flex" vs-justify="space-around">
        <vs-col vs-w="12" class="px-5">
          <h1 class="text-center py-10 mt-10">Nenhum Endereço de serviço</h1>
          <h1 class="text-center mb-10">
            <vs-icon size="large" icon="sentiment_dissatisfied" />
          </h1>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";
import BlueprintTabContent from "./manage-devices/blueprint/tabContent.vue";
import DevicesTabContent from "./manage-devices/device/tabContent.vue";

export default {
  props: {
    cliente: { required: true },
    contrato: { required: true },
    os: Object,
    onlyActives: Boolean,
    onlyPests: Boolean,
  },

  components: {
    ...components,
    BlueprintTabContent,
    DevicesTabContent,
  },

  data() {
    return {
      enderecos: [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.8,
      },
    };
  },

  methods: {
    async getEnderecosParaAssociar() {
      try {
        this.enderecos = await this.$http.post("getEnderecosParaAssociar", {
          id_cliente: this.contrato.id_cliente,
          id_contrato: this.contrato.id,
        });
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      }
    },
  },

  async mounted() {
    await this.getEnderecosParaAssociar();
  },
};
</script>
